import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private msalAuthService: MsalService, public authService: AuthService) { }

  ngOnInit(): void {
  }

  logout() {
    this.msalAuthService.logout();
  }

}
